import { render, staticRenderFns } from "./video-border.vue?vue&type=template&id=6d3c29e6&scoped=true"
import script from "./video-border.vue?vue&type=script&lang=js"
export * from "./video-border.vue?vue&type=script&lang=js"
import style0 from "./video-border.vue?vue&type=style&index=0&id=6d3c29e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3c29e6",
  null
  
)

export default component.exports